import React, { useState } from 'react';

import styles from './HighUsageSchools.module.scss';
import commonStyles from '../../DataDashboard.module.scss';
import BackLink from '../../../../components/BackLink';
import { Button } from '@squirrellearningltd/go-teacher-components';
import Tabs from '../../../../components/Tabs';
import Tab from '../../../../components/Tab';
import { useEffectOnce } from 'react-use';

import { HIGH_USAGE_SCHOOLS } from '../../services/graphql';
import { useLazyQuery } from '@apollo/react-hooks';

import { navigate } from '@reach/router';
import useClipboard from '../../utils/copyToClipboard';

const TABS = {
    Student: 1,
    Staff: 2,
    Parent: 3,
};

const HighUsageSchools = () => {
    const [selectedTab, setSelectedTab] = useState(TABS.Student);
    const { copyToClipboard, isCopied, error } = useClipboard();

    const [
        handleSchoolUsageScore,
        {
            data: schoolData,
            loading: schoolDataLoading,
            error: schoolDataError,
        },
    ] = useLazyQuery(HIGH_USAGE_SCHOOLS);

    const getSchoolUsageScore = (orderBy) => {
        handleSchoolUsageScore({
            variables: {
                orderBy
            }
        })
    };


    const copyEmails = () => {
        if (schoolData.schoolUsageScore) {
            const adminEmails = schoolData.schoolUsageScore.map((schoolUsage) => schoolUsage.school.admins.map((admin) => admin.email)).flat();
            const copyParser = (data) => data.filter(Boolean).join(';');
            copyToClipboard(adminEmails, copyParser);
        } else {
            alert('No data to copy');
        }

    };

    useEffectOnce(() => {
        if (!schoolData) {
            getSchoolUsageScore('student');
        }
    });

    return (
        <>
            <BackLink to='/dataDashboard' text='Back' />

            <div className={commonStyles.dataDashboardHeader}>
                <h2>High Usage Schools</h2>
                <Button type='button' onClick={() => copyEmails()}>
                    Copy Emails
                </Button>
            </div>

            <Tabs className={styles.TabsContainer}>
                <Tab
                    selected={selectedTab === TABS.Student}
                    onClick={
                        () => {
                            setSelectedTab(TABS.Student);
                            getSchoolUsageScore('student')
                        }
                    }
                >
                    Student
                </Tab>
                <Tab
                    selected={selectedTab === TABS.Staff}
                    onClick={() => {
                        setSelectedTab(TABS.Staff);
                        getSchoolUsageScore('teacher');
                    }}
                >
                    Staff
                </Tab>
                <Tab
                    selected={selectedTab === TABS.Parent}
                    onClick={() => {
                        setSelectedTab(TABS.Parent);
                        getSchoolUsageScore('parent');
                    }}
                >
                    Parent
                </Tab>
            </Tabs>

            {schoolDataError && <p>{schoolDataError.message}</p>}

            {selectedTab === 1 ? (
                <>
                    <div className={styles.contentContainer}>
                        <div className={styles.contentHeadline}>
                            <div>School Name</div>
                            <div>Av Monthly Logs </div>
                        </div>
                        <div className={styles.contentValues}>
                            {schoolDataLoading && <p>Loading...</p>}
                            {
                                schoolData && schoolData.highUsageSchools.length ? schoolData.highUsageSchools.map((schoolUsageScore, index) =>
                                    <div key={index}
                                        className={styles.contentValueRow}
                                        onClick={() => navigate(`/dataDashboard/schoolStats/schoolHome/${schoolUsageScore.school.id}`)}>

                                        <div>{schoolUsageScore.school.name} ({schoolUsageScore.school.schoolCode})</div>
                                        <div className={styles.usageValue}>{schoolUsageScore.studentAverageMonthlyLogs ?? 0}</div>
                                    </div>
                                ) : !schoolDataLoading && <p>No data available</p>
                            }
                        </div>
                    </div>
                </>
            ) : selectedTab === 2 ? (
                <>
                    <div className={styles.contentContainer}>
                        <div className={styles.contentHeadline}>
                            <div>School Name</div>
                            <div>Av Monthly Logs </div>
                        </div>
                        <div className={styles.contentValues}>
                            {schoolDataLoading && <p>Loading...</p>}
                            {
                                schoolData && schoolData.highUsageSchools.length ? schoolData.highUsageSchools.map((schoolUsageScore, index) =>
                                    <div key={index}
                                        className={styles.contentValueRow}
                                        onClick={() => navigate(`/dataDashboard/schoolStats/schoolHome/${schoolUsageScore.school.id}`)}>

                                        <div>{schoolUsageScore.school.name} ({schoolUsageScore.school.schoolCode})</div>
                                        <div className={styles.usageValue}>{schoolUsageScore.teacherAverageMonthlyLogs ?? 0}</div>
                                    </div>
                                ) : !schoolDataLoading && <p>No data available</p>
                            }
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className={styles.contentContainer}>
                        <div className={styles.contentHeadline}>
                            <div>School Name</div>
                            <div>Av Monthly Logs </div>
                        </div>
                        <div className={styles.contentValues}>
                            {schoolDataLoading && <p>Loading...</p>}
                            {
                                schoolData && schoolData.highUsageSchools.length ? schoolData.highUsageSchools.map((schoolUsageScore, index) =>
                                    <div key={index}
                                        className={styles.contentValueRow}
                                        onClick={() => navigate(`/dataDashboard/schoolStats/schoolHome/${schoolUsageScore.school.id}`)}>

                                        <div>{schoolUsageScore.school.name} ({schoolUsageScore.school.schoolCode})</div>
                                        <div className={styles.usageValue}>{schoolUsageScore.parentAverageMonthlyLogs ?? 0}</div>
                                    </div>
                                ) : !schoolDataLoading && <p>No data available</p>
                            }
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default HighUsageSchools;
